module.exports = __webpack_public_path__ + "static/media/logo-black.ec61bdd7.png";